import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { SVGIconModule } from '@progress/kendo-angular-icons';
import { SVGIcon, moreVerticalIcon } from '@progress/kendo-svg-icons';
import { PrivilegedAccessSummary } from '../../../../services/identity-security.service';

@Component({
  selector: 'app-privileged-access',
  standalone: true,
  imports: [CommonModule, ButtonsModule, SVGIconModule],
  templateUrl: './privileged-access.component.html',
  styleUrl: './privileged-access.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivilegedAccessComponent {
  data = input<PrivilegedAccessSummary | null>(null);
  isLoading = input<boolean>(true);
  openDetail = output<void>();

  public moreVerticalIcon: SVGIcon = moreVerticalIcon;
  public menuItems = [{ text: 'View Data' }];

  public onMenuSelect(event: { text?: string }): void {
    if (event?.text === 'View Data') {
      this.openDetail.emit();
    }
  }
}
